import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {
  "title": "Accessibility Statement",
  "layout": "content",
  "includeToc": true,
  "permalink": "/accessibility/"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "Accessibility-Statement",
      "style": {
        "position": "relative"
      }
    }}>{`Accessibility Statement`}</h1>
    <p>{`The Office of Natural Resources Revenue (ONRR) is committed to making its information and communication technologies accessible to individuals with disabilities by meeting or exceeding the requirements of Section 508 of the Rehabilitation Act of 1973, as amended.  Section 508 is a Federal law that requires agencies to provide individuals with disabilities access to electronic and information technology and data comparable to those who do not have disabilities, unless an undue burden would be imposed on the agency.  To meet this commitment, our web templates have been designed to meet or exceed the Section 508 standards and to conform to the W3C Web Content Accessibility Guidelines (WCAG) 2.0, Level AA.`}</p>
    <br />
    <p>{`The Section 508 standards are the technical requirements and criteria that are used to measure conformance with the law.  More information on Section 508 and the technical standards can be found at `}<a parentName="p" {...{
        "href": "https://www.section508.gov/"
      }}>{`Section508.gov`}</a>{`. `}</p>
    <br />
    <p>{`The `}<a parentName="p" {...{
        "href": "https://www.w3.org/TR/WCAG20/"
      }}>{`Web Content Accessibility Guidelines (WCAG) 2.0`}</a>{` can be found at the `}<a parentName="p" {...{
        "href": "https://www.w3.org/"
      }}>{`W3C website`}</a>{`.`}</p>
    <br />
    <p>{`If you have feedback or concerns related to the accessibility of any content on this website, or have ideas or comments that would help us improve the accessibility and usability of our website, please email `}<a parentName="p" {...{
        "href": "mailto:onrrweb@onrr.gov"
      }}>{`onrrweb@onrr.gov`}</a>{`. If applicable, please include the web address or URL and the specific problems you have encountered.`}</p>
    <br />
    <p>{`If you would like to file a Section 508 related complaint, please submit the complaint in writing to the `}<a parentName="p" {...{
        "href": "https://doi.gov/pmb/eeo"
      }}>{`DOI Office of Diversity, Inclusion and Civil Rights`}</a>{` at the following address:  `}</p>
    <br />
    <p>{`U.S. Department of the Interior `}<br />{`
Director, Office of Diversity, Inclusion and Civil Rights `}<br />{`
Mail Stop 4359 `}<br />{`
1849 C Street N.W. `}<br />{`
Washington, D.C. 20240 `}<br /></p>
    <br />
    <p>{`The ODICR will apply the complaint procedures outlined in `}<a parentName="p" {...{
        "href": "https://www.govinfo.gov/app/details/CFR-2004-title43-vol1/CFR-2004-title43-vol1-part17"
      }}>{`43 CFR Part 17, Subpart E`}</a>{`, which are established to implement Section 504 for resolving allegations of discrimination in a Federally conducted program or activity.`}</p>
    <br />
    <p>{`If you would like to file a Section 508-related complaint, please contact the DOI Section 508 Program via email at `}<a parentName="p" {...{
        "href": "mailto:section508@ios.doi.gov"
      }}>{`section508@ios.doi.gov`}</a>{` or phone (202) 208-1530.`}</p>
    <br />
    <p>{`If you have comments or questions related to the DOI Section 508 Program, please contact the DOI Section 508 Program Coordinator via email at `}<a parentName="p" {...{
        "href": "mailto:section508@ios.doi.gov"
      }}>{`section508@ios.doi.gov`}</a>{` or phone (202) 208-1530. For comments or questions regarding bureau/office Section 508 programs, please contact the `}<a parentName="p" {...{
        "href": "https://doi.gov/ocio/section508-contacts"
      }}>{`Bureau/Office Section 508 Coordinator`}</a>{`.`}</p>
    <br />
    <h2 {...{
      "id": "Accessibility-Resources",
      "style": {
        "position": "relative"
      }
    }}>{`Accessibility Resources`}</h2>
    <h3 {...{
      "id": "DOI-Section-508-Program",
      "style": {
        "position": "relative"
      }
    }}>{`DOI Section 508 Program `}</h3>
    <p>{`The `}<a parentName="p" {...{
        "href": "https://doi.gov/ocio/section508"
      }}>{`DOI Section 508 Program`}</a>{` manages and oversees the implementation of Section 508 of the Rehabilitation Act of 1973 and ensures information and communication technologies developed, procured, maintained and used by DOI is accessible to everyone. `}</p>
    <br />
    <h3 {...{
      "id": "Telecommunications-Relay-Services",
      "style": {
        "position": "relative"
      }
    }}>{`Telecommunications Relay Services`}</h3>
    <p>{`Individuals who are deaf, deafblind, hard of hearing, or have a speech disability may dial 711 (TTY, TDD, or TeleBraille) to access telecommunications relay services. For more information visit the `}<a parentName="p" {...{
        "href": "https://www.fcc.gov/consumers/guides/711-telecommunications-relay-service"
      }}>{`711 consumer guide`}</a>{`.`}</p>
    <br />
    <h3 {...{
      "id": "FEDSHIREVETS-DOI-POC",
      "style": {
        "position": "relative"
      }
    }}>{`FEDSHIREVETS DOI POC `}</h3>
    <p><a parentName="p" {...{
        "href": "https://www.fedshirevets.gov/veterans-council/agency-directory/department-of-interior/"
      }}>{`FEDSHIREVETS DOI POC`}</a>{`: Schedule A Selective Placement Program Coordinator Points of Contact at DOI`}</p>
    <br />
    <h3 {...{
      "id": "ACCESS-Center",
      "style": {
        "position": "relative"
      }
    }}>{`ACCESS Center`}</h3>
    <p>{`The `}<a parentName="p" {...{
        "href": "https://doi.gov/accommodations"
      }}>{`ACCESS Center`}</a>{`, (formerly the Assisted Technology Center or ATC) is a resource center that offers consultation, information, advice and demonstration of assistive technology, safety, and accommodation solutions to increase workplace accessibility and safety for all employees.`}</p>
    <br />
    <h3 {...{
      "id": "Disability",
      "style": {
        "position": "relative"
      }
    }}>{`Disability`}</h3>
    <p><a parentName="p" {...{
        "href": "https://doi.gov/pmb/eeo/"
      }}>{`DOI's Office of Diversity, Inclusion and Civil Rights`}</a>{` provides information on civil rights and equal opportunity programs including `}<a parentName="p" {...{
        "href": "https://doi.gov/pmb/eeo/Public-Civil-Rights"
      }}>{`disability-related topics`}</a>{`.`}</p>
    <br />
    <h3 {...{
      "id": "Architectural-Barriers-Act-of-1968-42-USC-§§-4151--57",
      "style": {
        "position": "relative"
      }
    }}>{`Architectural Barriers Act of 1968 (42 U.S.C. §§ 4151--57)`}</h3>
    <p>{`The Architectural Barriers Act (ABA) requires access to facilities that are designed, built, altered, or leased with Federal funds. The Access Board is the federal agency responsible for enforcing the ABA. The Access Board's accessibility standards are available on the `}<a parentName="p" {...{
        "href": "https://www.access-board.gov/aba/"
      }}>{`Access Board website`}</a>{` along with `}<a parentName="p" {...{
        "href": "https://www.access-board.gov/enforcement/"
      }}>{`information about filing a complaint`}</a>{`.`}</p>
    <br />
    <br />
    <p>{`Last updated: December 28, 2022`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      